/**
 * @generated SignedSource<<2535cc86e5bae5430e484720b45d7abc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeaderWithImage_draft$data = {
  readonly mainMedia: {
    readonly originalUrl: string | null;
  } | null;
  readonly name: string | null;
  readonly posterFrameMedia: {
    readonly originalUrl: string | null;
  } | null;
  readonly user: {
    readonly ethereumWalletAddress: {
      readonly publicProfile: {
        readonly profileName: string | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentType": "HeaderWithImage_draft";
};
export type HeaderWithImage_draft$key = {
  readonly " $data"?: HeaderWithImage_draft$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderWithImage_draft">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "originalUrl",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderWithImage_draft",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "ethereumWalletAddress",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PublicProfile",
              "kind": "LinkedField",
              "name": "publicProfile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftMedia",
      "kind": "LinkedField",
      "name": "mainMedia",
      "plural": false,
      "selections": (v0/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftMedia",
      "kind": "LinkedField",
      "name": "posterFrameMedia",
      "plural": false,
      "selections": (v0/*:: as any*/),
      "storageKey": null
    }
  ],
  "type": "NftItemDraft",
  "abstractKey": null
};
})();

(node as any).hash = "538378f1d55f8b9e5ef5f4f35ff5fa5d";

export default node;
